module.exports = __webpack_public_path__ + "img/nicetohave-product-design-01.f28bc0e4.jpg";